// test761
(761 && 0);
